import SelectOptionPage from '../components/SelectOptionPage';
import { connect } from 'react-redux';
import { changeModel } from '../actions';
import localization from '../helpers/localization.js';
import { getWebpAwareExtension } from '../helpers/webpSupport';

const mapStateToProps = (state, ownProps) => {
    return {
        selections: buildModels(state.benchModel.availableBenchModels, state.benchModel.shape, state.benchModel.model),
        selected: state.benchModel.model.name,
        showPrices: state.clientConfiguration.showPrices,
        prices: state.optionPricing.benchBrands,
        selectioDescription: localization[state.benchModel.model.descriptionLocalizationStringName],
        infoText: localization.chooseBenchModelInfo,
        hideHeader: true
      
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (e) => {
        dispatch(changeModel(e));
    }
});

const SelectBenchModelPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectOptionPage);

export default SelectBenchModelPageContainer;

let currentModels = {};

let buildModels = (models, currentShape, benchModel) => {
    if (currentModels.shape !== currentShape || currentModels.model !== benchModel) {
        currentModels.models = models.map(m => {  
            m.id = m.name;
            m.thumbnail = "./img/models/" + m.name + getWebpAwareExtension();
            return m;
        });
        currentModels.model = benchModel;
    }
    return currentModels.models;
}
